export const reAddressTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_ADDRESS_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_ADDRESS_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_ADDRESS_TYPE_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_ADDRESS_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_ADDRESS_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_ADDRESS_TYPE_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_ADDRESS_TYPE_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'GET_LIST_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'GET_LIST_ADDRESS_TYPE_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'CREATE_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'CREATE_ADDRESS_TYPE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'DELETE_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'DELETE_ADDRESS_TYPE_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'UPDATE_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'UPDATE_ADDRESS_TYPE_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_ADDRESS_TYPE_REQUEST',
		SUCCESS : 'RESTORE_ADDRESS_TYPE_SUCCESS',
		FAILURE : 'RESTORE_ADDRESS_TYPE_FAILURE'
	},
	CLEAR: 'CLEAR_ADDRESS_TYPE'
}